import {
  Roboto,
  Source_Serif_4,
  Lobster,
  Lugrasimo,
  Barriecito,
  Bangers,
  Butcherman,
  Mogra,
  Chewy,
  Borel,
  Satisfy,
  Limelight,
  Pirata_One,
  Shrikhand,
  Gwendolyn,
  Orbitron,
  Audiowide,
  Wallpoet,
  Atma,
  Margarine,
  Parisienne,
  Nunito,
  Aleo
} from 'next/font/google';

const roboto = Roboto({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-roboto'
});
const sourceSerif4 = Source_Serif_4({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-source-serif-4'
});
const lobster = Lobster({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-lobster'
});
const lugrasimo = Lugrasimo({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-lugrasimo'
});
const barriecito = Barriecito({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-barriecito'
});
const bangers = Bangers({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-bangers'
});
const butcherman = Butcherman({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-butcherman'
});
const mogra = Mogra({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-mogra'
});
const chewy = Chewy({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-chewy'
});
const borel = Borel({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-borel'
});
const satisfy = Satisfy({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-satisfy'
});
const limelight = Limelight({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-limelight'
});
const pirataOne = Pirata_One({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-pirata-one'
});
const shrikhand = Shrikhand({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-shrikhand'
});
const gwendolyn = Gwendolyn({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-gwendolyn'
});
const orbitron = Orbitron({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-orbitron'
});
const audiowide = Audiowide({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-audiowide'
});
const wallpoet = Wallpoet({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-wallpoet'
});
const atma = Atma({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-atma'
});
const margarine = Margarine({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-margarine'
});
const nunito = Nunito({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-nunito'
});
const parisienne = Parisienne({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-parisienne'
});
const aleo = Aleo({
  subsets: ['latin'],
  weight: '400',
  variable: '--font-aleo'
});

export const fonts = [
  // Standard fonts
  { name: 'Roboto', font: roboto.style.fontFamily, className: roboto.variable },
  { name: 'Nunito', font: nunito.style.fontFamily, className: nunito.variable },
  { name: 'Source Serif', font: sourceSerif4.style.fontFamily, className: sourceSerif4.variable },
  { name: 'Aleo', font: aleo.style.fontFamily, className: aleo.variable },
  { name: 'Gwendolyn', font: gwendolyn.style.fontFamily, className: gwendolyn.variable },
  { name: 'Parisienne', font: parisienne.style.fontFamily, className: parisienne.variable },
  // Custom fonts
  { name: 'Lobster', font: lobster.style.fontFamily, className: lobster.variable },
  { name: 'Bangers', font: bangers.style.fontFamily, className: bangers.variable },
  { name: 'Borel', font: borel.style.fontFamily, className: borel.variable },
  { name: 'Lugrasimo', font: lugrasimo.style.fontFamily, className: lugrasimo.variable },
  { name: 'Mogra', font: mogra.style.fontFamily, className: mogra.variable },
  { name: 'Chewy', font: chewy.style.fontFamily, className: chewy.variable },
  { name: 'Satisfy', font: satisfy.style.fontFamily, className: satisfy.variable },
  { name: 'Limelight', font: limelight.style.fontFamily, className: limelight.variable },
  { name: 'Shrikhand', font: shrikhand.style.fontFamily, className: shrikhand.variable },
  { name: 'Atma', font: atma.style.fontFamily, className: atma.variable },
  { name: 'Margarine', font: margarine.style.fontFamily, className: margarine.variable },
  // Weird fonts
  { name: 'Barriecito', font: barriecito.style.fontFamily, className: barriecito.variable },
  {
    name: 'Pirata One',
    font: pirataOne.style.fontFamily,
    className: pirataOne.variable
  },
  { name: 'Orbitron', font: orbitron.style.fontFamily, className: orbitron.variable },
  { name: 'Audiowide', font: audiowide.style.fontFamily, className: audiowide.variable },
  { name: 'Wallpoet', font: wallpoet.style.fontFamily, className: wallpoet.variable },
  { name: 'Butcherman', font: butcherman.style.fontFamily, className: butcherman.variable }
];

export const postscriptFontNames = {
  Roboto: 'Roboto-Regular',
  'Source Serif': 'SourceSerif4Roman-Regular',
  Lobster: 'Lobster-Regular',
  Bangers: 'Bangers-Regular',
  Barriecito: 'Barriecito-Regular',
  Lugrasimo: 'Lugrasimo-Regular',
  Mogra: 'Mogra-Regular',
  Chewy: 'Chewy-Regular',
  Borel: 'Borel-Regular',
  Satisfy: 'Satisfy-Regular',
  Limelight: 'Limelight-Regular',
  Shrikhand: 'Shrikhand-Regular',
  'Pirata One': 'Pirata-One',
  Gwendolyn: 'Gwendolyn-Regular',
  Orbitron: 'Orbitron-Regular',
  Audiowide: 'Audiowide-Regular',
  Wallpoet: 'Wallpoet',
  Butcherman: 'Butcherman-Regular'
};

export const fontClassNames = fonts.map((font) => font.className).join(' ');
